import { RouteConfig } from 'vue-router';
import { SubmissionRoutes } from '../submission/routes';
import { TARGET_ENTITIES } from '@/utils/constants';

const AMDashboardModule = () =>
  import(
    /* webpackChunkName: 'dashboard' */ '@/modules/amDashboard/AMDashboardModule.vue'
  );
const SubmissionRequestsPage = () =>
  import(
    /* webpackChunkName: 'dashboard' */ './pages/SubmissionRequestsPage.vue'
  );
const PendingSubmissionRequestsPage = () =>
  import(/* webpackChunkName: 'dashboard' */ './pages/PendingRequestsPage.vue');

const QCQueriesPage = () =>
  import(/* webpackChunkName: 'dashboard' */ './pages/QCQueriesPage.vue');

export const PendingReqPageName =
  'dashboard.organisation.investments.submission-requests.pending';
export const AllReqPageName =
  'dashboard.organisation.investments.submission-requests.all';
export const QcQueriesPageName =
  'dashboard.organisation.investments.submission-requests.qc-queries';

export const AmDashboardRoutes: RouteConfig[] = [
  {
    path: 'submission-requests',
    component: AMDashboardModule,
    props: true,
    meta: {
      middlewares: {
        canAccessEntity: TARGET_ENTITIES.submissionRequests
      }
    },
    children: [
      {
        path: '',
        meta: {
          title: 'Incomplete Requests'
        },
        name: PendingReqPageName,
        component: PendingSubmissionRequestsPage
      },
      {
        path: 'all',
        meta: {
          title: 'All Requests'
        },
        name: AllReqPageName,
        component: SubmissionRequestsPage
      },
      {
        path: 'qc-queries',
        meta: {
          title: 'Queries'
        },
        name: QcQueriesPageName,
        component: QCQueriesPage
      }
    ]
  },
  ...SubmissionRoutes
];
